import { render, staticRenderFns } from "./StatementBody.vue?vue&type=template&id=0b16fd12&scoped=true&"
import script from "./StatementBody.vue?vue&type=script&lang=js&"
export * from "./StatementBody.vue?vue&type=script&lang=js&"
import style0 from "./StatementBody.vue?vue&type=style&index=0&id=0b16fd12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b16fd12",
  null
  
)

export default component.exports